
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/facebook/facebookConfigView.tmpl");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var FacebookSubscribedPagesView = require("manager-views/data-sources/conversation-sources/facebook/FacebookSubscribedPagesView");
    var FacebookSubscribedPagesCollection = require("manager-collections/data-sources/conversation-sources/FacebookSubscribedPagesCollection");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");
    var KPContent = require("ui.components/kpContent/kpContent");
    var SingleSelect = require("ui/singleselect-new/Singleselect");

    var FacebookConfigView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        FacebookConfigView = Marionette.ItemView.extend({
            template : template,
            className : "conversation-source-edit-config-container facebook-config-container",
            ui : {
                scrollableArea: ".conversation-sources-config",
                dialogContainer: ".dialog-container",
                facebookLoginButton: ".facebook-login-button",
                currentlySubscribedContainer: ".currently-subscribed-container",
                currentlySubscribedList: ".currently-subscribed-list",
                cancelButton: ".button-cancel",
                backButton: ".button-back",
                nextButton: ".button-next",
                doneButton: ".button-done",
                progressBar: ".conversation-sources-progress-bar",
                externalUserContainer: ".external-user-container",
                externalUserLearnMore: ".external-user-learn-more",
                externalUserSingleSelectContainer: ".external-user-single-select-container"
            },
            uiComponents : {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancelClick"
                    }
                },
                backButton:{
                    type: Button,
                    options: {
                        el: "view.ui.backButton",
                        permutation: Button.PERMUTATION.BTN
                    },
                    events: {
                        "click": "_onBackClick"
                    }
                },
                nextButton: {
                    type: Button,
                    options: {
                        el: "view.ui.nextButton",
                        disabled: true,
                        initState: Button.STATES.DISABLED,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    }
                },
                doneButton: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT,
                        initState:"view._getDoneButtonState"
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                },
                progressBar: {
                    type: StepIndicator,
                    options: {
                        el: "view.ui.progressBar",
                        permutation: StepIndicator.PERMUTATION.G,
                        steps: [
                            { text: LE.translator.translate("LEManager.dataSources.conversationSources.general.activation.stepName"), state: "view._getActivationStepComplete"},
                            { text: LE.translator.translate("LEManager.dataSources.conversationSources.general.config.stepName"), state: StepIndicator.STATE.CURRENT}
                        ]
                    }
                },
                externalUserLearnMore: {
                    type: KPContent,
                    options: {
                        container: "view.ui.externalUserLearnMore",
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: "facebook-connector",
                        showKPIcon: true
                    }
                },
                externalUserSingleSelect: {
                    type: SingleSelect,
                    options: {
                        container: "view.ui.externalUserSingleSelectContainer",
                        permutation: SingleSelect.PERMUTATION.B,
                        theme: SingleSelect.THEME.DEFAULT,
                        errorPosition: SingleSelect.ERROR_POSITION.RIGHT,
                        useCreateNewItemOption: false,
                        list: {
                            maxShownItems: 5,
                            itemHeight: 30
                        },
                        inputField: {
                            placeholder: LE.translator.translate("LEManager.dataSources.conversationSources.facebook.external.user.agent.manager.name")
                        },
                        items : "view._getAgentManagersCollection",
                        selectedItem: "view._setAgentManagerSelected"
                    },
                    events: {
                        "change": "_onExternalUserChange",
                        "input:change": "_onExternalUserChange"
                    }
                }
            },

            initialize : function (options) {
                LEManager.logger.debug("FacebookConfigView:initialize");
                this.connectorModels = options.connectorModels;
                this.agentManagers = options.agentManagers || [];
                this.agentManagerModel = options.agentManagerModel;
                this.channel = LEManager.media.channel("conversationSources");
                this._bindEvents();
            },

            onRender : function (options) {
                this.facebookSubscribedPagesCollection = new FacebookSubscribedPagesCollection(this._getSubscribedPagesNames(this.connectorModels));
                this.facebookSubscribedPagesView = new FacebookSubscribedPagesView({el: this.ui.currentlySubscribedList, collection: this.facebookSubscribedPagesCollection});
                this.ui.currentlySubscribedList.append(this.facebookSubscribedPagesView.render().$el);

                this._showSubscribedPagesNamesAndExternalUser();

                _.defer(_.bind(function() {
                    LE.initFacebook();
                }, this));
            },

            showDialog : function (dialogView) {
                this.dialogView = dialogView;
                this.ui.dialogContainer.append(this.dialogView.render().$el);
            },

            closeDialog : function () {
                if(this.dialogView) {
                    this.dialogView.close();
                    this.dialogView = null;
                }
            },

            isDialogOpen : function () {
                return !!this.dialogView;
            },

            refreshSubscribedPagesNames: function(options) {
                this.connectorModels = options.connectorModels || [];
                this.facebookSubscribedPagesCollection = new FacebookSubscribedPagesCollection(this._getSubscribedPagesNames(this.connectorModels));
                this.facebookSubscribedPagesView.setCollection({collection: this.facebookSubscribedPagesCollection});
                this._scrollToBottom();
                this._showSubscribedPagesNamesAndExternalUser();
            },

            _bindEvents: function(){
                this.listenTo(this, "page:closeButtonClick", this._onCancelClick);
            },

            _getAgentManagersCollection: function() {
                return this.agentManagers;
            },

            _scrollToBottom: function() {
                var scrollBottom = this.ui.scrollableArea.scrollTop() + this.ui.scrollableArea.height();
                this.ui.scrollableArea.scrollTop(scrollBottom);
            },

            _getAgentManagerSelected: function() {
                if(this.agentManagerModel) {
                    return this.agentManagerModel.getValue();
                }
            },

            _setAgentManagerSelected: function() {
                if(this._isAgentManagerExists()) {
                    return this.agentManagerModel.getValue();
                }
            },

            _isAgentManagerExists: function() {
                var agentManagerSelected = this._getAgentManagerSelected();
                if(!_.isEmpty(agentManagerSelected)) {
                    var isExists = _.some(this.agentManagers, function(user) {
                        if(user.id && user.id.toString() === agentManagerSelected) {
                            return true;
                        }
                    }, this);
                    return isExists;
                }
                return false;
            },

            _onExternalUserChange : function (componentId, eventName, value) {
                if (_.isObject(value) && _.isObject(value.item)){
                    LEManager.logger.debug("FacebookConfigView:_onExternalUserChange - id: " + value.item.id);
                    this.channel.trigger("facebook:external:user:changed", value.item.id);
                } else if(_.isObject(value) && value.value === "") {
                    this.channel.trigger("facebook:external:user:changed", "");
                }
            },

            _showSubscribedPagesNamesAndExternalUser: function() {
                if(!_.isEmpty(this.connectorModels)) {
                    this.ui.currentlySubscribedContainer.removeClass("hide");
                    this.ui.externalUserContainer.removeClass("hide");
                } else {
                    this.ui.currentlySubscribedContainer.addClass("hide");
                    this.ui.externalUserContainer.addClass("hide");
                    LEManager.notifier.showInfo({content : LE.translator.translate("LEManager.dataSources.conversationSources.facebook.no.page.subscribed")});
                }
            },

            _getSubscribedPagesNames: function(connectorModels) {
                var names = [];
                _.each(connectorModels, function(model){
                    names.push({name: model.get("name")});
                }, this);
                return names;
            },

            _onDoneClick: function(){
                this._hideErrors();
                var externalUserSelected = this.uiComponents.externalUserSingleSelect.getSelectedItem();
                var externalUserText = this.uiComponents.externalUserSingleSelect.getInputValue();

                if (_.isEmpty(externalUserSelected) && externalUserText !== "") {
                    this.uiComponents.externalUserSingleSelect.setError(true, LE.translator.translate("LEManager.dataSources.conversationSources.facebook.external.user.not.exist.error"));
                } else {
                    this.channel.trigger("facebook:config:done");
                }
            },

            _hideErrors: function () {
                this.uiComponents.externalUserSingleSelect.setError(false);
            },

            _onCancelClick: function(){
                this.channel.trigger("facebook:config:cancel");
            },

            _onBackClick: function(){
                this.channel.trigger("facebook:config:back");
            },

            _getActivationStepComplete: function(){
                return StepIndicator.STATE.COMPLETED;
            },

            onClose : function () {
                LEManager.logger.debug("FacebookConfigView:onClose");
                this.channel.trigger("facebook:config:dialog:close");
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return FacebookConfigView;
});
